import { supabase } from '../supabase';

export type ClassRegistrationEmailResult = {
  ok: boolean;
  emails: {
    student: {
      status: 'sent' | 'failed';
      message?: string;
    };
    teacher: {
      status: 'sent' | 'failed' | 'skipped';
      message?: string;
    };
  };
};

export async function sendClassRegistrationConfirmation(registrationId: string) {
  const { data, error } = await supabase.functions.invoke('send-class-registration-email', {
    body: { registrationId },
  });

  if (error) {
    throw error;
  }

  return data as ClassRegistrationEmailResult;
}
